import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowUp, FiMail, FiPhone, FiLinkedin, FiInstagram, FiCalendar } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-cta">
          <div>
            <h2>Ready to ship something real?</h2>
            <p>Get a written scope, a fixed-price quote, and a real timeline — usually within a week of our first call.</p>
          </div>
          <Link to="/schedule" className="btn btn-accent">
            <FiCalendar /> Schedule a meeting
          </Link>
        </div>

        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-mark logo-mark--image">
                <img src="/img/company-logo.png" alt="THINKINGWORLD" />
              </span>
              <span>THINKING<span className="logo-faint">WORLD</span></span>
            </div>
            <p>
              A product studio building websites, mobile apps, IoT platforms and
              digital marketing engines for healthcare, real estate, ecommerce,
              nutrition and education brands.
            </p>
            <div className="footer-social">
              <a href="https://www.linkedin.com/company/thinkingworld" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FiLinkedin /></a>
              <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FiInstagram /></a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Company</h4>
            <Link to="/about">About</Link>
            <Link to="/services">Services</Link>
            <Link to="/process">Process</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className="footer-col">
            <h4>Industries</h4>
            <Link to="/industries/healthcare">Healthcare</Link>
            <Link to="/industries/real-estate">Real Estate</Link>
            <Link to="/industries/ecommerce">Ecommerce</Link>
            <Link to="/industries/natural-nutrition">Natural &amp; Nutrition</Link>
            <Link to="/industries/education">Education</Link>
          </div>

          <div className="footer-col">
            <h4>Resources</h4>
            <Link to="/resources/blog">Blog</Link>
            <Link to="/resources/videos">Videos</Link>
            <Link to="/resources/webinars">Webinars</Link>
            <Link to="/resources/case-studies">Case Studies</Link>
          </div>

          <div className="footer-col">
            <h4>Get in touch</h4>
            <a href="mailto:thinkingworld813@gmail.com"><FiMail /> thinkingworld813@gmail.com</a>
            <a href="tel:+919597965911"><FiPhone /> +91 95979 65911</a>
            <span className="footer-loc">Tamil Nadu, India · Working remotely</span>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {year} THINKINGWORLD. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="mailto:thinkingworld813@gmail.com?subject=Privacy%20Policy%20request">Privacy</a>
            <a href="mailto:thinkingworld813@gmail.com?subject=Terms%20request">Terms</a>
            <button
              className="footer-back-top"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              type="button"
            >
              Back to top <FiArrowUp />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
